import { debounce } from '@/utils/api';
import moment from 'moment';
import { ref, getCurrentInstance } from 'vue';
import { Message } from 'irm-ui';

// 管理日程渲染相关缓存与更新逻辑
export const useScheduleCache = (options = {}) => {
	// 提取配置对象中的 `onRenderUpdate` 回调函数，用于在视图需要刷新时触发外部更新操作。
	const { onRenderUpdate } = options;

	const { proxy } = getCurrentInstance();

	// 存储已缓存日程数据的月份键（YYYYMM 格式）。
	const cachedScheduleMonthKeys = ref([]);

	const resetCachedScheduleMonthKeys = val => {
		cachedScheduleMonthKeys.value = val || [];
	};

	// 当 `date` 变化且对应的月份键不在缓存中时，触发视图刷新逻辑
	const updateScheduleRender = debounce(
		function (date) {
			const currDateKey = moment(date).format('YYYYMM');
			const includeCacheKey = cachedScheduleMonthKeys.value.includes(currDateKey);
			if (!includeCacheKey) {
				// 在视图需要刷新时触发外部更新操作。
				onRenderUpdate?.();
			}
		},
		180,
		false
	);

	const getScheduleRange = date => {
		if (!date) return [];
		// 日程请求区间 当前月份加上前后月
		const rangeStart = moment(date).subtract(1, 'months').startOf('month').valueOf();
		const rangeEnd = moment(date).add(1, 'months').endOf('month').valueOf();
		const range = [rangeStart, rangeEnd];
		return range;
	};

	const setScheduleCacheWithRange = (date, range = []) => {
		if (!date || !range.length || range.length < 2) return;

		const [rangeStart, rangeEnd] = range;

		const _cache = []; // 覆盖缓存
		[moment(date).format('YYYYMM'), moment(rangeStart).format('YYYYMM'), moment(rangeEnd).format('YYYYMM')].forEach(
			d => {
				_cache.push(d);
			}
		);
		// 记录已经拿到数据的日期信息
		resetCachedScheduleMonthKeys([...new Set(_cache)]);
	};

	let loadingMessageVm;
	const hideLoadingMessage = () => {
		if (loadingMessageVm) loadingMessageVm.close();
	};
	const showLoadingMessage = () => {
		loadingMessageVm = Message({
			message: proxy.$t('enterprise.loading'),
			customClass: 'vm-loading-message'
		});
	};

	return {
		cachedScheduleMonthKeys,
		updateScheduleRender,
		resetCachedScheduleMonthKeys,

		getScheduleRange,
		setScheduleCacheWithRange,

		hideLoadingMessage,
		showLoadingMessage
	};
};
